module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn",
    attrs: {
      "id": "Toc_Link11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CHAPTER 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Are You Ready? Calc Prereqs")])])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("It’s a good idea to spend a few minutes reviewing what you’re supposed to have learned in high school in all those classes meant to prepare you for your first calculus class.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "Toc_Link12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5.1 What you think you learned")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl-j"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("*")]), _vm._v(" Up to ninth grade: Really complicated arithmetic, including elaborate long-division problems, which everyone knew could be done more easily on a calculator.")]), _vm._v(" "), _c('p', {
    staticClass: "bl-j"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("*")]), _vm._v(" Tenth through twelfth grades: Well, algebra, geometry, and trigonometry, right?")]), _vm._v(" "), _c('p', {
    staticClass: "bl-j"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Algebra")]), _vm._v(".    How to solve complicated questions involving water going upstream, boats going downstream, and trout fishing, by throwing in a lot of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("’s and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v("’s and hoping some plausible numbers come out at the end, like they caught four trout apiece and were moving at a rate of 7 miles per hour, or vice versa.")]), _vm._v(" "), _c('p', {
    staticClass: "bl-j"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Geometry")]), _vm._v(".    How to show that one line that was incredibly far away from another line, barely on the same page even, was actually parallel to the first line. Why anyone cared about this escaped you at the time, but on the other hand, what was the point of dissecting the frogs in biology?")]), _vm._v(" "), _c('p', {
    staticClass: "bl-j"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Trigonometry")]), _vm._v(".    Hmmm, missed that altogether, did we? But it’s worth mentioning separately because it’s the first math word, coming well before “calculus,” that has the capacity to intimidate other people.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "Toc_Link13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5.2 What you really need to know on the first day of class")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2-tns"
  }, [_vm._v("ALGEBRA")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1.")]), _vm._v(" Be able to factor something like "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − 6"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 8 into ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − 2)("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − 4).")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("2.")]), _vm._v(" Be able to find the values of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" that satisfy "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − 7"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 9 = 0 using the quadratic formula.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3.")]), _vm._v(" Know that "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" = ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(")("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(") and that "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" + "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" doesn’t factor.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4.")]), _vm._v(" Know that "), _c('img', {
    staticClass: "align1",
    attrs: {
      "alt": "image",
      "height": "26",
      "src": "images/eqi-pg18-1.jpg",
      "width": "70"
    }
  }), _vm._v(" DOES NOT EQUAL "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 4 OR "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 2.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5.")]), _vm._v(" Know that "), _c('img', {
    staticClass: "align1",
    attrs: {
      "alt": "image",
      "height": "25",
      "src": "images/eqi-pg18-2.jpg",
      "width": "126"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6.")]), _vm._v(" Know that "), _c('img', {
    staticClass: "align2",
    attrs: {
      "alt": "image",
      "height": "44",
      "src": "images/eqi-pg18-3.jpg",
      "width": "180"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7.")]), _vm._v(" Be able to find which values of "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" satisfy "), _c('img', {
    staticClass: "align2",
    attrs: {
      "alt": "image",
      "height": "41",
      "src": "images/eqi-pg18-4.jpg",
      "width": "89"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "stx"
  }, [_vm._v("If you are mystified by some of these topics, you will need to fill in the gaps in your knowledge before you can expect to be a master of the calculus universe.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("FUNCTION NOTATION")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Throughout calculus, functions are denoted by "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") as in")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − 7"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 5")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("What the “("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")” indicates is that "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" is the quantity that varies. We fondly call "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" the “variable.” It plays the role that the coin slot plays on a vending machine at a highway rest stop. You put 75 cents in the vending machine, and out comes a comb. You put in $1.00 and out comes a pack of playing cards. Same with the function "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f,")]), _vm._v(" except no comb or playing cards. You put in 2 for "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" and you get "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("(2) = (2)"), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − 7(2) + 5 = −5. You put in 3 for "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" and you get "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("(3) = (3)"), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − 7(3) + 5 = −7.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("ABSOLUTE VALUE FUNCTION")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("This is one of the truly misunderstood functions of our time. It doesn’t deserve its bad reputation.")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = |"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("|")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("What could be more innocuous? It’s just an "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" with two little bars on either side. The most important thing is to know the actual definition of the absolute value function. Many people just remember it intuitively, saying to themselves, “Well, it just means make "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" positive.” That’s true, but unless it’s applied carefully, it can lead to trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Officially,")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "48",
      "src": "images/eqd-pg19-1.jpg",
      "width": "201"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("That’s it. So "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("(3) = |3| = 3 and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("(−2) = | − 2| = 2. No problem.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But what do you do if "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = |"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − 2|? This may make you nervous. But there’s no need to break out in hives, because we know the definition of the absolute value function, so we know exactly what to do. Let’s just write out what the definition says.")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "48",
      "src": "images/eqd-pg19-2.jpg",
      "width": "315"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Let’s write it one more time, slightly simplified.")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "48",
      "src": "images/eqd-pg19-3.jpg",
      "width": "281"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Not so bad. Suppose that we wanted to graph it. Then we would graph "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(" = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − 2 for "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" ≥ 2 and we would graph "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(" = −("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − 2) for "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" < 2. And voilà, "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#fig5.1"
    }
  }, [_vm._v("Figure 5.1")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you want to show off, you can define "), _c('img', {
    staticClass: "align1",
    attrs: {
      "alt": "image",
      "height": "25",
      "src": "images/eqi-pg19-1.jpg",
      "width": "81"
    }
  }), _vm._v(". This definition is equivalent to the one we gave above because "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" is always positive and the square root of a positive number always refers to the positive square root. But this definition can be confusing if you don’t have an irresistible affinity for square roots.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("GEOMETRY")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Geometry played an important role in teaching you about the forms of a mathematical proof, assuming you weren’t too busy passing through puberty to pay attention. We will quickly recap what you really need to know in Chapter 7, “Lines, Circles, and Their Friends.” As to all the stuff about intersecting bisectors and the side-angle-side theorem, you can leave it to Euclid. We won’t need much of it. If you come away with some idea of what a proof is and what similar triangles are, you’re ahead of the game.")]), _vm._v(" "), _c('p', {
    staticClass: "img1",
    attrs: {
      "id": "fig5.1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "232",
      "src": "images/pg20-1.jpg",
      "width": "278"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap-bnss"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Figure 5.1")]), _vm._v(" Function "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = |"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" − 2|.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("TRIGONOMETRY")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#fig5.2"
    }
  }, [_vm._v("Figure 5.2")]), _vm._v(" contains most of what you need to know.")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "197",
      "src": "images/eqd-pg20-1.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "img1",
    attrs: {
      "id": "fig5.2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "114",
      "src": "images/pg20-2.jpg",
      "width": "276"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap-bns"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Figure 5.2")]), _vm._v(" Three sides of a right triangle with one angle equal to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("θ")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "eqd-ns"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "173",
      "src": "images/eqd-pg21-1.jpg",
      "width": "259"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("We can measure an angle in either radians or degrees. One full circle can be described as having 360 degrees or 2"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v(" radians. Since 360° = 2"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v(" radians, dividing both sides by 360 shows that 1° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/180 radians.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You should know the values of all of the trig functions at the standard angles of 0°, 30°, 45°, 60°, 90°, and 180°. You should also know what these angles are in radians.")]), _vm._v(" "), _c('p', {
    staticClass: "eqd-bns"
  }, [_vm._v("1° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/180 radians")]), _vm._v(" "), _c('p', {
    staticClass: "eqd1"
  }, [_vm._v("30° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/6 radians")]), _vm._v(" "), _c('p', {
    staticClass: "eqd1"
  }, [_vm._v("45° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/4 radians")]), _vm._v(" "), _c('p', {
    staticClass: "eqd1"
  }, [_vm._v("60° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/3 radians")]), _vm._v(" "), _c('p', {
    staticClass: "eqd1"
  }, [_vm._v("90° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/2 radians")]), _vm._v(" "), _c('p', {
    staticClass: "eqd1"
  }, [_vm._v("180° = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v(" radians")]), _vm._v(" "), _c('p', {
    staticClass: "eqd-tns"
  }, [_vm._v("360° = 2"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v(" radians")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Converting from degrees to radians is easy. You multiply by "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/180 to go from degrees to radians, and by 180/"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v(" to go from radians to degrees.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Two triangles are helpful here, the 30°-60°-90° triangle and the 45°-45°-90° triangle, shown in "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#fig5.3"
    }
  }, [_vm._v("Figure 5.3")]), _vm._v(". Facts like sin (30°) = 1/2 can be read right off these triangles.")]), _vm._v(" "), _c('p', {
    staticClass: "img1",
    attrs: {
      "id": "fig5.3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "151",
      "src": "images/pg21.jpg",
      "width": "385"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap-bns"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Figure 5.3")]), _vm._v(" Two triangles to remember.")]), _vm._v(" "), _c('p', {
    staticClass: "img1-ns",
    attrs: {
      "id": "fig5.4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "212",
      "src": "images/pg22.jpg",
      "width": "280"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Figure 5.4")]), _vm._v(" Finding trig functions of 120°, or 2"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("π")]), _vm._v("/3 radians.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If you need to find the trig functions at some angle larger than 90°, like 120°, that’s no problem at all. First draw the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(" axes and use the fact that 120° is 60° less than 180°. So draw a 30-60-90 triangle on top of the negative "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("-axis, with the 60° angle at the origin. See "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#fig5.4"
    }
  }, [_vm._v("Figure 5.4")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Labeling the bottom edge with a minus sign, since it is along the negative "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("-axis, we have "), _c('img', {
    staticClass: "align",
    attrs: {
      "alt": "image",
      "height": "25",
      "src": "images/eqi-pg22-1.jpg",
      "width": "154"
    }
  }), _vm._v(" and cos (120°) = −1/2.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are a variety of trigonometric identities, but almost all the information you’re likely to need is in one, namely,")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "43",
      "src": "images/eqd-pg22-1.jpg",
      "width": "200"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("That one is worth remembering.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("We will list a few others, just for fun and in case you want to refer to them later:")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "232",
      "src": "images/eqd-pg22-2.jpg",
      "width": "275"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You may eventually run into the infamous “inverse trig functions” arcsin, arccos, arctan, and the other members of the arc family. The meaning is simple: If "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(" = sin "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x,")]), _vm._v(" then we say "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" = arcsin "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("y")]), _vm._v(". For a particular example, since "), _c('img', {
    staticClass: "align",
    attrs: {
      "alt": "image",
      "height": "23",
      "src": "images/eqi-pg23-1.jpg",
      "width": "42"
    }
  }), _vm._v(" = sin(60°), we can calculate that arcsin "), _c('img', {
    staticClass: "align",
    attrs: {
      "alt": "image",
      "height": "23",
      "src": "images/eqi-pg23-2.jpg",
      "width": "60"
    }
  }), _vm._v(" = 60° = π/3 radians. And that’s all we need to know about inverse trig functions for now.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_vm._v("COMPOSING FUNCTIONS")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Beethoven composed symphonies and went down in history. In this section we’ll show you how to compose functions. Probably history won’t blink, though it may give a chuckle or two. Just goes to show, “You can use the same name, but that don’t make it the same.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Composing two functions means taking the variable "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x,")]), _vm._v(" applying one function to it, and then applying another function to the result. So if we take the functions")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "58",
      "src": "images/eqd-pg23-1.jpg",
      "width": "115"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("we can "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("compose")]), _vm._v(" them by, say, first doing "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v(" and then "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v(". We’d write")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "25",
      "src": "images/eqd-pg23-2.jpg",
      "width": "238"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("We just replaced each "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" that occurred in the function "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") by a "), _c('img', {
    staticClass: "align",
    attrs: {
      "alt": "image",
      "height": "23",
      "src": "images/eqi-pg23-3.jpg",
      "width": "26"
    }
  }), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Or we could first do "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v(" and then "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "27",
      "src": "images/eqd-pg23-3.jpg",
      "width": "255"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Here, we replaced each "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" that occurred in the function "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") by an "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 7.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Notice that we get two different functions, so "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("the order is important")]), _vm._v(". The order that we use to calculate the new function is the opposite of what you ought to have been taught about using multiple forks in elegant restaurants: While you’re supposed to start with the outermost fork and proceed inward till dessert, here you start with the innermost function and proceed outward. For those of you who have never learned how to eat in an elegant restaurant, learn calculus and make oodles of money. Then you can go to the most expensive restaurants and use the forks in any order you want.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Here’s a trick if you get confused. Let’s take two new functions")]), _vm._v(" "), _c('p', {
    staticClass: "eqd-bns"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = cos "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")])]), _vm._v(" "), _c('p', {
    staticClass: "eqd-tns"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" + "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("and calculate the function "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("First take the function "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g,")]), _vm._v(" and everywhere you see an "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" on the right-hand side, put parentheses around it:")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")"), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" + ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Think of the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("’s in parentheses on the right-hand side as being "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("exact copies")]), _vm._v(" of the ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") you see on the left-hand side. This means that whatever gobbledygook you see in the parentheses on the left-hand side has to be reproduced exactly wherever you see ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") on the right-hand side. So,")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v(" (gobbledygook) = (gobbledygook)"), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" + (gobbledygook)")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In our case,")]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")) = ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("))"), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" + ("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v("))")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Finally, take equal signs very very seriously; you know what "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") equals, so everywhere you see "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") replace it with cos "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x:")])]), _vm._v(" "), _c('p', {
    staticClass: "eqd"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("f")]), _vm._v("("), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")) = "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("g")]), _vm._v(" (cos "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(") = (cos "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")"), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" + (cos "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Kind of scary that all the math you learned in the last five years of your life can be distilled to five pages. But then, we did leave out lots of important material that just happens to be not relevant to calculus. Take the side-angle-side theorem, for instance. Now aren’t you glad you learned that? And of course there was that unit in eighth grade on how to figure out the cost of a loose-leaf binder on sale for 30% off. So don’t worry. Those years were chock full of useful tidbits.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Besides, this was the period in your life when you had to deal with the onset of acne, hormonal tidal waves, and the overriding question, confronted every day: Would anyone sit with you at lunch? It’s amazing your teachers got anything to stick.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "Toc_Link14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_Toc_Link14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5.3 Computers and calculators: Our 2-bit friends")])])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("These days, chances are good that your calculus course will be using computers (running a computer algebra system), a graphing calculator, a programmable calculator, or perhaps regular old calculators. If so, you have entered the world of digital calculus. These tools can make your life easier when you do calculations and can increase the power and scope of your knowledge. They can allow you to experiment quickly with many examples, giving you a better understanding of the subject. On the other hand, they can lead to frustrating moments when you have trouble finding the on/off switch or the alt-3 keys. So let’s talk about the various possibilities in turn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("First, computer algebra systems. There are several common systems that are used in calculus. They go by the names Mathematica, Mathcad, Maple, and DERIVE. Each is a computer algebra system, a software package that juggles formulas and equations. These programs can do algebra, like factor "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")]), _vm._v(" − 5"), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("x")]), _vm._v(" + 6 or simplify the fraction "), _c('img', {
    staticClass: "align1",
    attrs: {
      "alt": "image",
      "height": "45",
      "src": "images/eqi-pg25-1.jpg",
      "width": "58"
    }
  }), _vm._v(". That’s a nice feature to have. But in fact, they can do a lot more than that. They can do many of the basic calculations of calculus: take derivatives of simple functions (and not-so-simple functions), and determine indefinite and definite integrals. These are operations that we will be talking about throughout this book, and they form the basis for calculus. Sophisticated calculators can also do these basic operations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("You may be tempted to ask, “Wait a minute. If these machines can do calculus, why do I have to learn it? Let them do it, and I’ll just hang out at the pool and drink brightly colored tropical drinks.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But of course, the point is that the computers don’t understand what they are doing. They cannot interpret their results and use them to make bundles of money the way you can. And a good thing too, or they’d be hanging out by the pool and you’d be spending all your time learning how to polish memory chips.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One place that computers and calculators do a great job is in graphing functions. After you put in a function, they can graph it, display it from all sides, and determine where its peaks and bottoms occur. Combined with a solid understanding of techniques of graphing, you will become a graphing grandmaster. You can graph GNP, GPA, and MTV.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The worst thing about computers and calculators is figuring out how to get started on the little gadgets. Once you get the hang of which keys to push, they can be tremendously useful. But nothing is more frustrating than wasting time on the mechanics of the machine instead of applying its power. Too many students spend an hour trying to find a command, only to find out they’re looking in the wrong manual. So the key is to harness the power of the machine.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The best way to do this is to get someone else to show you. Latch onto a fellow student or an instructor or a computer consultant until you can work through a few example problems. Make sure they show you the whole thing, from the time you turn on the power until you put the thing away. With computing, it doesn’t help to know 99% of the process for solving your problem if you don’t know which directory your account is in or how to access a program. So have someone else go through it all with you first.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As you progress with computation, the time will come when the machine decides to test you. It will lose your files or ignore your keystrokes or otherwise test your sanity. The usual response to this is “Oh, no, I did something wrong, I’m going to get in trouble and fail the class. Help!” The correct response is “I bet that cute cyber-star over there would love to come and help me figure out what hung my computer.” Consider these situations a chance to experiment with your social skills and the computer lab as your own giant petrie dish of opportunities.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("There are various other places where computers and calculators are useful in calculus. For instance, they can give a good intuition for limits in general and the limiting process that occurs in derivatives in particular. In Section 22.5 on numerical integration, there are large quantities of numbers to add together. We have included short programs at the relevant points in the book that can be utilized on a programmable calculator or computer to do calculations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Calculators and computers can be powerful tools in learning calculus; they offer you possibilities of in-depth understanding that were previously available only to demigods. Using them to explore the manifold wonders of calculus can lead to a deeper grasp of the subject. And remember, knowledge is power and power costs 10 cents per kilowatt.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eef91ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter5.vue
// module id = 81
// module chunks = 0